import React from 'react';
import { Card, Row } from 'react-bootstrap';
import style from '../project/Widgets/Articles/style.module.less';

function ButtonsCardContainer(props) {
  return (
    <Row className={style.rowResult}>
      <Card>
        <Card.Body>
          <div className={style.buttonCardWithArticle}>
            {props.children}
          </div>
        </Card.Body>
      </Card>
    </Row>
  );
}

export default ButtonsCardContainer;
